import $ from 'jquery';
import 'slick-carousel';

export default class Recommend {
	constructor() {
		this.selectors = {
			slider: '.js-recommend-slider',
			slide: '.js-recommend-slide',
			image: '.js-slider-image',
			arrow: '.js-recommend-arrow'
		};

		this.$slider = $(this.selectors.slider);
		this.$image = $(this.selectors.image);
		this.$window = $(window);
		this.render();
	}

	init() {
		this.$slider.each((i, item) => {
			let firstBreak;
			let secondBreak;
			let thirdBreak;
			let fourthBreak;
			const $slider = $(item);
			const slidesNumber = $slider.find(this.selectors.slide).length;
			switch (slidesNumber) {
				case 4:
					firstBreak = slidesNumber;
					secondBreak = slidesNumber - 1;
					thirdBreak = fourthBreak = slidesNumber - 2;
					break;
				case 3:
					firstBreak = secondBreak = slidesNumber;
					thirdBreak = fourthBreak = slidesNumber - 1;
					break;
				case 2:
				case 1:
					firstBreak = secondBreak = thirdBreak = fourthBreak = slidesNumber;
					break;
				default:
					firstBreak = 5;
					secondBreak = 4;
					thirdBreak = 3;
					fourthBreak = 2;
			}

			$slider.not('.slick-initialized').slick({
				slidesToShow: firstBreak,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				infinite: true,
				speed: 0,
				dotsClass: 'recommend__dots',
				prevArrow: '<span class="recommend__arrow recommend__arrow_type_prev js-recommend-arrow"><svg><use xlink:href="/assets/images/icon.svg#icon_arrow-left"></use></svg></span>',
				nextArrow: '<span class="recommend__arrow recommend__arrow_type_next js-recommend-arrow"><svg><use xlink:href="/assets/images/icon.svg#icon_arrow-left"></use></svg></span>',
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: secondBreak
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: thirdBreak
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: fourthBreak,
						dots: true,
						arrows: false
					}
				}]
			});
		});
	}

	setPos() {
		const height = this.$image.height();
		const $arrow = $(this.selectors.arrow);
		const value = height / 2 - 4;

		$arrow.css({top: value});
	}

	render() {
		if (this.$slider.length) {
			this.init();
			this.$window.on('resize', () => this.setPos());
			this.$window.on('load', () => this.setPos());
		}
	}

}



/** WEBPACK FOOTER **
 ** ./app/blocks/recommend/recommend.js
 **/